module.exports = __webpack_public_path__ + "static/media/availible_ic_nodes.22c9a494.svg";